export const MESSAGE_CODE_SHOW_SUBSCRIBE_CARD = 14000;
export const MESSAGE_CODE_HIDE_SUBSCRIBE_CARD = 14001;
